<div class="modal-body d-flex align-items-center">
  <img
    src="../../../../assets/icons/key.svg"
    class="mr-3"
    [attr.alt]="'alt.keyIcon' | translate"
  />
  <p>{{ 'Messages.To continue, select the EDS key in the NCALayer application.' | translate}}</p>
</div>
